import { Button, Carousel, Select, Tabs } from 'flowbite-react';
import { useEffect, useState } from 'react';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link, useParams } from 'react-router-dom';
import { Equipment } from '../../Models/Equipment';
import EquipmentApi from '../../Api/EquipmentApi';
import RequestQuote from './RequestQuote';
import ProductSpecs from './ProductSpecs';
import ProductFiles from './ProductFiles';
import ProductFeatures from './ProductFeatures';
import { EquipmentFeature } from '../../Models/EquipmentFeature';
import { FileTypeEnums } from '../../Models/FileType';
import { OrderItem } from '../../Models/OrderItem';
import OrderApi from '../../Api/OrderApi';
import { useAppSelector } from '../../Reducers/store';
import { Order } from '../../Models/Order';
import { toast } from 'react-toastify';
import { formatNumbers } from '../../Utils';
import ProductVideos from './ProductVideos';
import EmailModal from '../Forms/WarehouseAvailability';

export default function Display() {
  const { id } = useParams();
  const { userModel } = useAppSelector((state) => state.user);
  const [equipmentData, setEquipmentData] = useState<Equipment | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showRequestQuote, setShowRequestQuote] = useState<boolean>(false);
  const [itemQuantity, setItemQuantity] = useState<number>(1);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState<Equipment>();
  const handleOpenEmailModal = (equipment: Equipment) => {
    setSelectedEquipment(equipment);
    setShowEmailModal(true);
  };

  useEffect(() => {
    const index = photoFiles.findIndex((p) => p.fileUrl === selectedImage);
    if (index !== -1) setCurrentIndex(index);
  }, [selectedImage]);

  const photoFiles =
    equipmentData?.files?.filter((x) => x.fileTypeId === FileTypeEnums.Photo) ||
    [];

  const handleThumbnailClick = (url: string, index: number) => {
    setSelectedImage(url);
    setCurrentIndex(index);
  };
  const displayedImage =
    selectedImage ||
    (photoFiles.length > 0 ? photoFiles[0].fileUrl : blankImage);

  const closeModal = () => setIsModalOpen(false);
  const goToPrevious = () => {
    const newIndex = (currentIndex - 1 + photoFiles.length) % photoFiles.length;
    setSelectedImage(photoFiles[newIndex].fileUrl!);
    setCurrentIndex(newIndex);
  };

  const openModal = () => {
    if (!selectedImage && photoFiles.length > 0) {
      // fallback to the first image
      setSelectedImage(photoFiles[0].fileUrl!);
      setCurrentIndex(0);
    } else {
      const index = photoFiles.findIndex((p) => p.fileUrl === selectedImage);
      setCurrentIndex(index >= 0 ? index : 0);
    }

    setIsModalOpen(true);
  };

  const goToNext = () => {
    const newIndex = (currentIndex + 1) % photoFiles.length;
    setSelectedImage(photoFiles[newIndex].fileUrl!);
    setCurrentIndex(newIndex);
  };
  const getEquipment = () => {
    if (id) {
      setIsLoading(true);
      EquipmentApi.getEquipmentDisplay(id)
        .then((res) => {
          setEquipmentData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setEquipmentData(null);
    }
  };

  useEffect(() => {
    getEquipment();
  }, [id]);

  const groupedByGroupName = equipmentData?.equipmentFeatures?.reduce(
    (acc, feature) => {
      const groupname = feature.groupName!;
      (acc[groupname] = acc[groupname] || []).push(feature);
      return acc;
    },
    Object.create([])
  );

  function handleRequestQuoteClick() {
    setShowRequestQuote(true);
  }

  const handleAddItemClick = async (equipment: Equipment) => {
    if (userModel) {
      let openOrderId =
        localStorage.getItem('openOrderId') &&
        Number(localStorage.getItem('openOrderId')) >= 0
          ? Number(localStorage.getItem('openOrderId'))
          : 0;
      if (openOrderId === 0) {
        await OrderApi.checkUserOpenOrder(userModel.id)
          .then((res) => {
            if (res.data) {
              openOrderId = res.data.id;
              localStorage.setItem('openOrderId', openOrderId.toString());
            } else {
              const newOrder: Order = {
                id: 0,
                businessName: null,
                contactName: null,
                contactPhone: null,
                contactEmail: null,
                notes: null,
                dateCreated: null,
                orderStatusId: 1,
                userId: userModel.id,
                billingAddressId: null,
                shippingAddressId: null,
                dateSubmitted: null,
                ponumber: null,
                clientId: userModel.clientId,
                shippingMethodId: 15,

                client: null,
                orderItems: [],
                billingAddress: null,
                shippingAddress: null,
                user: null,
              };
              OrderApi.addUpdateOrder(newOrder)
                .then((res) => {
                  if (res.data.success) {
                    openOrderId = Number(res.data.affectedEntityIdentifier);
                    localStorage.setItem('openOrderId', openOrderId.toString());
                  }
                })
                .catch((err) => {
                  setIsLoading(false);
                });
            }
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
      const newOrderItem: OrderItem = {
        id: 0,
        orderId: openOrderId,
        equipmentId: equipment.id,
        quantity: itemQuantity,
        equipment: equipment,
      };
      await OrderApi.addUpdateOrderItem(newOrderItem)
        .then((res) => {
          if (res.data.success) {
            toast.success('Item added to cart');
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
      await OrderApi.getOrderItemsCount(openOrderId)
        .then((res) => {
          if (res.data !== null) {
            localStorage.setItem('orderItemsCount', res.data.toString());
            window.dispatchEvent(new Event('updateOrderItemCount'));
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div className='w-full mt-4'>
      <div>
        <div className='container mx-auto p-2'>
          <div className='mb-2 border-b-2 flex'>
            <h1 className='text-gray-900 font-bold text-2xl'>
              {equipmentData?.number} - {equipmentData?.description}
            </h1>
          </div>
          <div className='flex flex-col lg:flex-row lg:gap-5 justify-between'>
            <div className='flex flex-col items-center w-full lg:w-1/3'>
              {/* Main Image (Click to Open Modal) */}
              <div className='relative w-full h-96 bg-gray-100 flex justify-center items-center cursor-pointer'>
                <img
                  src={displayedImage}
                  alt='Main Display'
                  className='h-56 sm:h-64 xl:h-80 2xl:h-96 object-contain m-auto'
                  onClick={openModal} // Open modal when clicked
                />
              </div>

              {/* Thumbnails Below the Image */}
              {photoFiles.length > 1 && (
                <div className='flex gap-2 mt-2 justify-center flex-wrap w-full'>
                  {photoFiles.map((data) => (
                    <button
                      key={data.id}
                      onClick={() => setSelectedImage(data.fileUrl!)}
                      className={`w-20 h-20 border-2 rounded-md overflow-hidden ${
                        selectedImage === data.fileUrl
                          ? 'border-blue-500'
                          : 'border-gray-300'
                      }`}
                    >
                      <img
                        src={data.fileUrl!}
                        alt={`${data.id}-thumbnail`}
                        className='w-full h-full object-cover'
                      />
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Image Modal */}
            {isModalOpen && (
              <div
                className='fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50'
                onClick={closeModal}
              >
                <div
                  className='relative w-full max-w-6xl px-8 flex items-center justify-between'
                  onClick={(e) => e.stopPropagation()} // prevent close when clicking inside
                >
                  {/* Prev Button */}
                  {photoFiles.length > 1 && (
                    <button
                      onClick={goToPrevious}
                      className='text-white bg-gray-700 hover:bg-gray-900 p-3 rounded-full'
                    >
                      ◀
                    </button>
                  )}

                  {/* Image in center */}
                  <div className='flex justify-center items-center flex-1 px-4'>
                    <img
                      src={selectedImage ?? undefined}
                      alt={equipmentData?.id.toString() ?? 'Price Bros'}
                      className='max-h-[80vh] w-auto min-w-[600px] object-contain rounded-lg shadow-lg'
                    />
                  </div>

                  {/* Next Button */}
                  {photoFiles.length > 1 && (
                    <button
                      onClick={goToNext}
                      className='text-white bg-gray-700 hover:bg-gray-900 p-3 rounded-full'
                    >
                      ▶
                    </button>
                  )}

                  {/* Close Button */}
                  <button
                    className='absolute top-4 right-4 bg-gray-700 text-white rounded-full p-2 hover:bg-gray-900'
                    onClick={closeModal}
                  >
                    ✕
                  </button>
                </div>
              </div>
            )}

            <div className='w-full'>
              <div className='flex my-auto p-5'>
                {equipmentData &&
                  (equipmentData.price ?? 0) > 0 &&
                  userModel && (
                    <div className='flex'>
                      <div className='text-center flex flex-col gap-2'>
                        <div className='my-auto'>Quantity:</div>
                        <Select
                          id='quantityId'
                          onChange={(e) =>
                            setItemQuantity(Number(e.target.value))
                          }
                          value={itemQuantity}
                          sizing='sm'
                          className=''
                        >
                          {[...Array(26).keys()].map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </Select>
                        <Button
                          type='button'
                          onClick={() => handleAddItemClick(equipmentData)}
                          className='buttonMain mt-2'
                        >
                          Add to Cart
                        </Button>
                      </div>
                      <div className='w-[2px] h-full content-center mx-5 font-semibold text-xl bg-gray-200'></div>
                    </div>
                  )}
                {equipmentData && userModel && (
                  <div className='flex'>
                    <div className='text-center flex flex-col gap-2'>
                      <Button
                        type='button'
                        onClick={() => handleAddItemClick(equipmentData)}
                        className='buttonMain mt-2'
                      >
                        Add to Cart
                      </Button>
                      <Button
                        type='button'
                        onClick={() => handleOpenEmailModal(equipmentData)}
                        className='buttonMain'
                      >
                        Check Availability
                      </Button>
                      <EmailModal
                        isOpen={showEmailModal}
                        onClose={() => setShowEmailModal(false)}
                        equipment={selectedEquipment!}
                        onSendSuccess={() => alert('Email sent!')}
                      />
                    </div>
                    <div className='w-[2px] h-full content-center mx-5 font-semibold text-xl bg-gray-200'></div>
                  </div>
                )}
                {equipmentData && !userModel && (
                  <div className='flex'>
                    <div className='h-full content-center gap-2'>
                      <Link to={'/login'}>
                        <Button
                          type='button'
                          // onClick={() => handleAddItemClick(equipmentData)}
                          className='buttonMain'
                        >
                          Login to order
                        </Button>
                      </Link>
                    </div>
                    <div className='w-[2px] h-full content-center mx-5 font-semibold text-xl bg-gray-200'></div>
                  </div>
                )}
                <div className='h-full my-auto'>
                  <Button
                    type='button'
                    onClick={() => handleRequestQuoteClick()}
                    className='buttonMain'
                  >
                    Request Quote
                  </Button>
                </div>
              </div>

              <div className='w-full'>
                {equipmentData && (
                  <div className='flex p-5 '>
                    <div className='flex flex-col gap-2'>
                      <table>
                        <tbody>
                          {equipmentData && (
                            <tr>
                              <td width={200}>
                                <span className='text-2xl font-bold'>
                                  List:
                                </span>
                              </td>
                              <td width={200}>
                                <span className='text-2xl font-bold'>
                                  {(equipmentData.price ?? 0) == 0 && (
                                    <span>Call For Price</span>
                                  )}
                                  {(equipmentData.listPrice ?? 0) > 0 && (
                                    <span>
                                      $
                                      {formatNumbers(
                                        equipmentData?.listPrice ?? 0
                                      )}
                                    </span>
                                  )}
                                </span>
                              </td>
                              <td width={100}>
                                {userModel &&
                                  equipmentData.manufacturer?.rimssOemvendorNumber?.startsWith(
                                    '1'
                                  ) && (
                                    <span className='text-2xl font-bold'>
                                      QOH:
                                    </span>
                                  )}
                              </td>
                              <td>
                                {userModel &&
                                  equipmentData.manufacturer?.rimssOemvendorNumber?.startsWith(
                                    '1'
                                  ) && (
                                    <span className='text-2xl font-bold'>
                                      {formatNumbers(
                                        equipmentData?.quantityOnHand ?? 0
                                      )}
                                    </span>
                                  )}
                              </td>
                            </tr>
                          )}
                          {equipmentData &&
                            userModel &&
                            equipmentData.manufacturer?.rimssOemvendorNumber?.startsWith(
                              '1'
                            ) && (
                              <tr>
                                <td>
                                  {userModel && (
                                    <span className='text-2xl font-bold'>
                                      Single Unit:
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    {(equipmentData.price ?? 0) == 0 && (
                                      <span>Call For Price</span>
                                    )}
                                    {(equipmentData.tradePrice ?? 0) > 0 && (
                                      <span>
                                        $
                                        {formatNumbers(
                                          equipmentData?.tradePrice ?? 0
                                        )}
                                      </span>
                                    )}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    QC:
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    {formatNumbers(
                                      equipmentData?.quantityCommitted ?? 0
                                    )}
                                  </span>
                                </td>
                              </tr>
                            )}
                          {equipmentData &&
                            userModel &&
                            equipmentData.manufacturer?.rimssOemvendorNumber?.startsWith(
                              '1'
                            ) && (
                              <tr>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    Stocking Dealer:
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    {(equipmentData.price ?? 0) == 0 && (
                                      <span>Call For Price</span>
                                    )}
                                    {(equipmentData.special1Price ?? 0) > 0 && (
                                      <span>
                                        $
                                        {formatNumbers(
                                          equipmentData?.special1Price ?? 0
                                        )}
                                      </span>
                                    )}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    AFS:
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    {formatNumbers(
                                      (equipmentData?.quantityOnHand ?? 0) -
                                        (equipmentData?.quantityCommitted ?? 0)
                                    )}
                                  </span>
                                </td>
                              </tr>
                            )}
                          {equipmentData &&
                            userModel &&
                            equipmentData.manufacturer?.rimssOemvendorNumber?.startsWith(
                              '2'
                            ) && (
                              <tr>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    Stocking Dealer:
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    {(equipmentData.price ?? 0) == 0 && (
                                      <span>Call For Price</span>
                                    )}
                                    {(equipmentData.special1Price ?? 0) > 0 && (
                                      <span>
                                        $
                                        {formatNumbers(
                                          equipmentData?.special1Price ?? 0
                                        )}
                                      </span>
                                    )}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'></span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'></span>
                                </td>
                              </tr>
                            )}
                          {equipmentData &&
                            userModel &&
                            equipmentData.manufacturer?.rimssOemvendorNumber?.startsWith(
                              '1'
                            ) && (
                              <tr>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    Max Discount:
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    {(equipmentData.price ?? 0) == 0 && (
                                      <span>Call For Price</span>
                                    )}
                                    {(equipmentData.special2Price ?? 0) > 0 && (
                                      <span>
                                        $
                                        {formatNumbers(
                                          equipmentData?.special2Price ?? 0
                                        )}
                                      </span>
                                    )}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    QOO:
                                  </span>
                                </td>
                                <td>
                                  <span className='text-2xl font-bold'>
                                    {formatNumbers(
                                      equipmentData?.quantityOnOrder ?? 0
                                    )}
                                  </span>
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </div>
                    <div className='w-[2px] h-full content-center mx-5 font-semibold text-xl bg-gray-200'></div>
                  </div>
                )}
              </div>
              <div className='w-full'>
                <div className='bg-white pt-3'>
                  <Tabs style='fullWidth'>
                    <Tabs.Item title='Specs' className='font-bold'>
                      <ProductSpecs equipment={equipmentData} />
                    </Tabs.Item>
                    {equipmentData &&
                      (
                        equipmentData?.files?.filter(
                          (c) => c.fileTypeId != FileTypeEnums.Photo
                        ) ?? []
                      ).length > 0 && (
                        <Tabs.Item title='Files' className='font-bold'>
                          <ProductFiles
                            data={
                              equipmentData?.files?.filter(
                                (c) => c.fileTypeId != FileTypeEnums.Photo
                              ) ?? []
                            }
                          />
                        </Tabs.Item>
                      )}
                    {groupedByGroupName &&
                      Object.entries(groupedByGroupName).map((feature) => (
                        <Tabs.Item title={feature[0]} className='font-bold'>
                          <ProductFeatures
                            features={feature[1] as EquipmentFeature[]}
                          />
                        </Tabs.Item>
                      ))}
                    {equipmentData?.equipmentVideos &&
                      equipmentData?.equipmentVideos.length > 0 && (
                        <Tabs.Item title='Videos' className='font-bold'>
                          <ProductVideos
                            data={equipmentData?.equipmentVideos ?? []}
                          />
                        </Tabs.Item>
                      )}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RequestQuote
        equipment={equipmentData}
        show={showRequestQuote}
        setShow={setShowRequestQuote}
      />
    </div>
  );
}
